import { render, staticRenderFns } from "./bulletinmanager.vue?vue&type=template&id=36a8397c&lang=pug"
import script from "./bulletinmanager.vue?vue&type=script&lang=js"
export * from "./bulletinmanager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports